import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../../lib/api";
import AdminLayout from "./AdminLayout";

// [label, statKey, destination route]
const CARDS = [
  ["Total Expressions of Interest", "totalInterest", "/admin/interest"],
  ["New Expressions of Interest", "newInterest", "/admin/interest"],
  ["Total Contact Enquiries", "totalContact", "/admin/contact"],
  ["New Contact Enquiries", "newContact", "/admin/contact"],
  ["Published Areas of Focus", "publishedActivities", "/admin/activities"],
  ["Published Initiatives", "publishedInitiatives", "/admin/initiatives"],
  ["Published Projects", "publishedProjects", "/admin/projects"],
  ["Published News", "publishedNews", "/admin/news"],
  ["Published Events", "publishedEvents", "/admin/events"],
  ["Gallery Items", "galleryItems", "/admin/gallery"],
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { client.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);

  return (
    <AdminLayout title="Dashboard">
      <p className="mb-6 text-sm text-ink-muted">An overview of website submissions and published content. Click any card to open the related page.</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map(([label, key, to]) => (
          <Link
            key={key}
            to={to}
            data-testid={`stat-${key}`}
            className="group block rounded-md border border-gold/20 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-gold/60 hover:shadow-md"
          >
            <div className="font-serif text-4xl text-maroon">{stats[key] ?? "—"}</div>
            <div className="mt-1 flex items-center justify-between text-sm text-ink-muted">
              <span>{label}</span>
              <span className="text-gold opacity-0 transition-opacity group-hover:opacity-100">→</span>
            </div>
          </Link>
        ))}
      </div>
    </AdminLayout>
  );
}
